import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";

const initialState = {
    starttime: null,
    endtime: null,
    selectedmrid: null,
    host: null,
    meetingname: null,
    selecteddate: null,
    uploadedimg: null,
    wedding: false,
    private: false,
    meals: []
};

const timeSlice = createSlice(
    {
        name: "time",
        initialState,
        reducers: {
            setstarttime: (state, action) => {
                state.starttime = action.payload;
            },
            setstartLogout: (state, action) => {
                state.starttime = null;
            },
            setendtime: (state, action) => {
                state.endtime = action.payload;
            },
            setendtimeLogout: (state, action) => {
                state.endtime = null;
            },
            setselectedmrid: (state, action) => {
                state.selectedmrid = action.payload
            },
            setselectedmrlogout: (state, action) => {
                state.selectedmrid = null
            },
            sethostname: (state, action) => {
                state.host = action.payload
            },
            sethostlogout: (state, action) => {
                state.host = null
            },
            setmeetingname: (state, action) => {
                state.meetingname = action.payload
            },
            setmeetingnamelogout: (state, action) => {
                state.meetingname = null
            },
            setselecteddatee: (state, action) => {
                state.selecteddate = action.payload
            },
            setselecteddatelogout: (state, action) => {
                state.selecteddate = null
            },
            setuploadedimg: (state, action) => {
                state.uploadedimg = action.payload
            },
            setuploadedimglogout: (state, action) => {
                state.uploadedimg = null
            },
            setwedding: (state, action) => {
                state.wedding = action.payload
            },
            setweddinglogout: (state, action) => {
                state.wedding = false
            },
            setprivate: (state, action) => {
                state.private = action.payload
            },
            setprivatelogout: (state, action) => {
                state.private = false
            },
            setmeals: (state, action) => {
                state.meals = action.payload
            },
            setmealslogout: (state, action) => {
                state.meals = null
            },
            setcompletelogout: (state, action) => {
                state.starttime = null
                state.endtime = null
                state.selectedmrid = null
                state.host = null
                state.meetingname = null
                state.selecteddate = null
                state.uploadedimg = null
                state.meals = null
                state.private = null
                state.wedding = null
            }

        },
    },
);


export const {
    setstarttime,
    setstartLogout,
    setendtime,
    setendtimeLogout,
    setselectedmrid,
    setselectedmrlogout,
    sethostname,
    sethostlogout,
    setmeetingname,
    setmeetingnamelogout,
    setselecteddatee,
    setselecteddatelogout,
    setuploadedimg,
    setuploadedimglogout, setcompletelogout,
    setwedding,
    setweddinglogout,
    setprivate,
    setprivatelogout,
    setmeals,
    setmealslogout,
} = timeSlice.actions;

export default timeSlice.reducer;
